import { render } from "./Index.vue?vue&type=template&id=be96ba0a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=be96ba0a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-be96ba0a"

export default script